// extracted by mini-css-extract-plugin
export default {"wrap":"uAtuy","link":"YKHzU","color__primary":"fhJR3","color__secondary":"napxx","size__m":"s4o45","size__l":"uSbHi","size__xl":"G6EMt","no-paddings":"INzqK"};